import React from 'react';
import '../assets/stylesheet/screenLoader.scss';

const ScreenLoader = () => {
  return (
    <div className="loader">
      <div className="loader-circle"></div>
    </div>
  );
};

export default ScreenLoader;
